import { Attach20Regular } from "@fluentui/react-icons";
import { ChangeEvent } from "react";
import { useStyle } from "./style";
import { FileInputProps } from "./types";
import { mergeClasses } from "@fluentui/react-components";

export const FileInput = (props: FileInputProps) => {
	const { accept, onFilesSelected, disabled } = props;
	const classes = useStyle();

	return (
		<>
			<label
				className={mergeClasses(classes.label, disabled ? classes.disabled : "")}
				htmlFor="fileUpload"
				children={<Attach20Regular />}
			/>
			<input
				id="fileUpload"
				type="file"
				multiple
				className={classes.input}
				onChange={(event: ChangeEvent<HTMLInputElement>) =>
					!!event.target.files && onFilesSelected(event.target.files)
				}
				onClick={(e: any) => (e.target.value = null)}
				accept={accept}
				disabled={disabled}
			/>
		</>
	);
};
